import clsx from 'clsx';
import type * as React from 'react';

export function Code(props: React.ComponentPropsWithoutRef<'code'>): React.ReactElement {
    const { children, className, ...codeProps } = props;

    return (
        <code
            className={clsx(
                'min-w-[1.625rem] max-w-full rounded bg-muted px-0.5 font-mono text-[0.875em] leading-none ring-1 ring-[var(--sp-color-border-control)] ',
                className
            )}
            autoCorrect="off"
            spellCheck="false"
            {...codeProps}
        >
            {children}
        </code>
    );
}
